import { Daisy } from "./Daisy";
import { fmtDate } from "../lib/api";

const money = (v) => `${Number(v || 0).toLocaleString("cs-CZ")} Kč`;

export const VoucherCard = ({ value, code = "HM00000-XXXXX", validUntil, testid = "voucher-card" }) => (
  <div className="voucher-card relative mx-auto flex aspect-[16/10] w-full max-w-[760px] overflow-hidden rounded-[28px] bg-[#F7F3EA] shadow-xl sm:aspect-[2/1]" data-testid={testid}>
    <div className="relative flex w-[42%] flex-col justify-between overflow-hidden bg-[#A3AC86] p-[4%] text-white">
      <Daisy size={150} className="absolute -bottom-10 -left-10 opacity-40" />
      <Daisy size={70} className="absolute right-4 top-1/3 hidden opacity-60 sm:block" />
      <div className="relative">
        <p className="font-serif text-[clamp(14px,3vw,26px)] font-black italic leading-none">hravá mateřinka</p>
        <p className="mt-1 text-[clamp(8px,1.2vw,11px)] uppercase tracking-[0.2em] opacity-90">Malé kroky, velké objevy</p>
      </div>
      <p className="relative font-script text-[clamp(16px,3.4vw,32px)] leading-tight text-[#FFF6D6]">S láskou<br />pro malé objevitele</p>
    </div>
    <div className="absolute left-[42%] top-0 h-full border-l-[3px] border-dashed border-[#F2C230]" />
    <div className="flex flex-1 flex-col items-center justify-center gap-[5%] p-[4%] text-center text-[#2D3426]">
      <p className="text-[clamp(9px,1.4vw,13px)] font-semibold uppercase tracking-[0.3em] text-[#D96B43]">Dárkový poukaz</p>
      <p className="font-serif text-[clamp(34px,8vw,76px)] font-black italic leading-none text-[#7A8460]" data-testid={`${testid}-value`}>{money(value)}</p>
      <div className="rounded-2xl border-2 border-dashed border-[#A3AC86] bg-white px-[6%] py-[2.5%] font-mono text-[clamp(12px,2.6vw,24px)] font-bold tracking-[0.2em]" data-testid={`${testid}-code`}>{code}</div>
      <p className="text-[clamp(9px,1.2vw,12px)] leading-snug text-[#6E7565]">Platnost do {validUntil ? fmtDate(validUntil) : "12 měsíců od nákupu"} · uplatněte v pokladně na webu Hravá mateřinka</p>
    </div>
  </div>
);
